module.exports = __webpack_public_path__ + "static/media/colicoli19.ff3c8552.webp";